import React from "react";
import { Card, Headline, Paragraph } from "_styleguide";
import "./SelectMethod.scss";
import {
  IconCreditCard,
  IconBrandMastercard,
  IconBuildingBank,
} from "@tabler/icons-react";

function SelectMethod(props) {
  return (
    <Card id="payment-information-method">
      <div className="apply-form">
        <Headline>{props.title}</Headline>
        {props.subtitle ? (
          <Paragraph
            opacity={0.6}
            align="left"
            size="14px"
            dangerouslySetInnerHTML={{
              __html: props.subtitle,
            }}
          />
        ) : null}
      </div>
      <div className="select-method">
        <div
          className="payment-method"
          onClick={() => props.setSelectedMethod("credit-card")}
        >
          <div className="pm-icon">
            <IconCreditCard />
          </div>
          <Paragraph>Credit Card</Paragraph>
        </div>
        <div
          className="payment-method"
          onClick={() => props.setSelectedMethod("debit-card")}
        >
          <div className="pm-icon">
            <IconBrandMastercard />
          </div>
          <Paragraph>Debit Card</Paragraph>
        </div>
        <div
          className="payment-method"
          onClick={() => props.setSelectedMethod("bank-account")}
        >
          <div className="pm-icon">
            <IconBuildingBank />
          </div>
          <Paragraph>Bank Account</Paragraph>
        </div>
      </div>
    </Card>
  );
}

export default SelectMethod;
